import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Howl, Howler } from 'howler';
import { Constants } from '../../../model/constants';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-player-audio',
  templateUrl: './player-audio.component.html',
  styleUrls: ['./player-audio.component.css']
})
export class PlayerAudioComponent implements OnInit, OnDestroy {
    // @Input() corsoId: number;
    // @Input() moduloId: number;
    @Input() filePath: string;
    sound: Howl;
    progressBarValue = 0;
    duration = 0;
    timer = 0;

    private progressInterval = interval(500);
    private progressSubcribe: Subscription;
    private soundLoadedInterval = interval(1000);
    private soundLoadedSubscribe: Subscription;

    constructor() { }

    ngOnInit() {
        this.initSound();
        this.checkSoundLoaded();
    }

    ngOnDestroy(): void {
        if (this.sound != null) {
            this.sound.stop();
            this.sound = null;
        }
        this.resetProgressInterval();
    }

    play() {
        this.sound.play();
        this.startProgressBar();
    }

    pause() {
        this.resetProgressInterval();
        this.sound.pause();
    }

    progressBarInput() {
        this.sound.seek(this.sound.duration() * (this.progressBarValue / 100));
        this.play();
    }

    progressBarChanging() {
        this.pause();
    }

    initSound() {
        this.sound = new Howl({
            // src: [Constants.API_ENDPOINT + 'modulo/audio/' + this.corsoId + '/' + this.moduloId],
            src: [Constants.MEDIA_ENDPOINT + this.filePath],
            format: ['mp3'],
            autoplay: false,
            loop: false,
            xhrWithCredentials: true
        });
    }

    startProgressBar() {
        this.progressSubcribe = this.progressInterval.subscribe(
            value => {
                this.progressBarValue = (this.sound.seek() / this.sound.duration() * 100) || 0;
                this.timer = this.sound.seek();
            }
        );
    }

    resetProgressInterval() {
        if (this.progressSubcribe != null) {
            this.progressSubcribe.unsubscribe();
        }
    }

    checkSoundLoaded() {
        this.soundLoadedSubscribe = this.soundLoadedInterval.subscribe(
            value => {
                if (this.sound != null && this.sound.duration() !== 0) {
                    this.duration = this.sound.duration();
                    this.soundLoadedSubscribe.unsubscribe();
                }
            }
        );
    }

}
